<template>
  <!-- 对齐 App order_item.dart：状态标题 + 字段行 + 分割线 + 统计行 -->
  <div class="order-item" @click="orderDetails">
    <!-- 状态标题（renting 橙色 / unpaid 红色 / 其他灰色） -->
    <div class="order-item-status" :class="statusClass">
      {{ statusText }}
    </div>

    <!-- 字段行：No. / Time rented / Venue rented -->
    <div class="order-item-row">
      <span class="order-item-label">{{ i18n.order_number }}</span>
      <span class="order-item-value">{{ item.pOrderid }}</span>
    </div>
    <div class="order-item-row">
      <span class="order-item-label">{{ i18n.time_rented }}</span>
      <span class="order-item-value">{{ item.pborrowtime | dateFmt }}</span>
    </div>
    <div class="order-item-row">
      <span class="order-item-label">{{ i18n.venue_rented }}</span>
      <span class="order-item-value">{{ item.pShopName }}</span>
    </div>

    <!-- 分割线 -->
    <div class="order-item-divider"></div>

    <!-- 统计行：左 时长 / 右 金额 -->
    <div class="order-item-stats">
      <div class="order-item-stat">
        <i class="order-item-stat-icon order-item-stat-icon-time"></i>
        <span class="order-item-stat-text">{{ orderDuration(item) }}</span>
      </div>
      <div class="order-item-stat">
        <i class="order-item-stat-icon order-item-stat-icon-money"></i>
        <span class="order-item-stat-text">{{ item.pCurrencyName }} {{ (item.pJiesuan || 0).toFixed(2) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs"
import { mapGetters } from "vuex"
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters(["locale"]),
    i18n() {
      return this.$t("order_item")
    },
    // 对齐 App _orderStatus：renting 橙色、unpaid 红色、其他灰色
    isZujie() {
      return (
        this.item.pJiesuanid === 0 &&
        (this.item.pZujie === 1 || this.item.pZujie === 4)
      )
    },
    isUnpaid() {
      // 状态 3 或 5 且已结算金额 < 总金额
      return (
        (this.item.pZujie === 3 || this.item.pZujie === 5) &&
        Number(this.item.settledAmount || 0) < Number(this.item.pJiesuan || 0)
      )
    },
    statusText() {
      // 对齐 App：未付清场景下优先返回 "Unpaid"（红色）
      if (this.isUnpaid) {
        return this.i18n.unpaid
      }
      const map = {
        0: this.i18n.type_0,
        1: this.i18n.type_1,
        2: this.i18n.type_2,
        3: this.i18n.type_3,
        4: this.i18n.type_4,
        5: this.i18n.type_5
      }
      return map[this.item.pZujie] || ""
    },
    statusClass() {
      if (this.isUnpaid) return "is-unpaid"
      if (this.item.pZujie === 1) return "is-renting"
      return ""
    }
  },
  data() {
    return {
      now: Date.now(),
      timer: null
    }
  },
  methods: {
    // 订单详情
    orderDetails() {
      this.$router.push(`/order/${this.item.porderid}`)
    },
    // 格式化时长（秒 → H:MM:SS）
    orderDateFmt(seconds = 0) {
      let hours = Number.parseInt(seconds / 3600)
      let minutes = Number.parseInt((seconds - hours * 3600) / 60)
      let second = Number.parseInt(seconds - hours * 3600 - minutes * 60)
      second = second < 10 ? "0" + second : second
      hours = hours < 10 ? "0" + hours : hours
      minutes = minutes < 10 ? "0" + minutes : minutes
      return `${hours}:${minutes}:${second}`
    },
    // 订单时长（与 App 端 _dateFmt 一致：renting 实时 / 其他 用 useMins * 60）
    // pborrowtime 为 UTC 时间字符串：按本地解析后需补回时区偏移再取时间戳（口径与 main.js dateFmt filter 一致），
    // 否则 new Date 会按本地时区解析导致时长偏大（如 UTC+8 偏大 8 小时），iOS 下空格格式还会解析为 NaN
    orderDuration(item) {
      let seconds = item.puseMins * 60
      if (item.pZujie === 1) {
        const bT = dayjs(item.pborrowtime)
          .add(dayjs().utcOffset() / 60, "hour")
          .valueOf()
        seconds = parseInt((this.now - bT) / 1000)
      }
      return this.orderDateFmt(seconds)
    }
  },
  created() {
    if (this.isZujie) {
      this.timer = setInterval(() => {
        this.now = Date.now()
      }, 1000)
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }
}
</script>

<style lang="less" scoped>
.order-item {
  width: 100%;
  // 对齐 App：itemColor 背景 + 12px 圆角
  background: #f8f6fc;
  border-radius: 24px;
  padding: 42px;
  box-sizing: border-box;
  cursor: pointer;

  &-status {
    // App 端状态文字 20.sp（750 设计稿 = 35px）bold
    font-size: 32px;
    font-weight: bold;
    color: #999;
    margin-bottom: 24px;

    &.is-renting {
      color: #ff8800; // 主题色
    }
    &.is-unpaid {
      color: #ff0000; // 红色提示
    }
  }

  &-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    &:last-of-type {
      margin-bottom: 24px;
    }
  }

  &-label {
    // 字段标签：16.sp 灰色
    font-size: 28px;
    color: #999;
  }

  &-value {
    // 字段值：16.sp 黑色
    font-size: 28px;
    color: #000;
  }

  &-divider {
    height: 1px;
    background: #ebebeb;
    margin-bottom: 24px;
  }

  &-stats {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &-stat {
    display: flex;
    align-items: center;
  }

  // 统计图标：CSS mask 着色为橙色（对齐 App 端 themeColor）
  &-stat-icon {
    display: block;
    width: 56px;
    height: 56px;
    background-color: #ff8800;
    -webkit-mask-size: 100% 100%;
    mask-size: 100% 100%;
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-position: center;
    mask-position: center;

    &-time {
      -webkit-mask-image: url(../../assets/imgs/icon_time.png);
      mask-image: url(../../assets/imgs/icon_time.png);
    }

    &-money {
      -webkit-mask-image: url(../../assets/imgs/icon_money.png);
      mask-image: url(../../assets/imgs/icon_money.png);
    }
  }

  &-stat-text {
    margin-left: 12px;
    // 统计文字：20.sp bold 黑色
    font-size: 32px;
    font-weight: bold;
    color: #000;
  }
}
</style>
